module.exports = __webpack_public_path__ + "img/gnzs11.67f93623.png";